import * as z from 'zod';

export const TagSchema = z.object({
  id: z.string(),
  name: z.string(),
  createdAt: z.coerce.date(),
});

export type TagType = z.infer<typeof TagSchema>;
